import LazyLoad from "vanilla-lazyload";

const lazyload = new LazyLoad();

export default lazyload;
